<template>
  <article class="social-card">
    <div class="social-card__header">
      <img
        class="social-card__avatar"
        src="https://mockmind-api.uifaces.co/content/human/222.jpg"
        alt="Alberto Saldarriaga"
      />
      <div class="social-card__info">
        <h5 class="social-card__name">Alberto Saldarriaga</h5>
        <span class="social-card__role">HR Assistant - @alberto_salda_95</span>
      </div>
      <button class="social-card__action">Add contact</button>
    </div>
    <div class="social-card__body">
      <!-- Content goes here -->
    </div>
    <div class="social-card__footer">
      <!-- Footer content goes here -->
    </div>
  </article>
</template>

<script>
export default {
  name: 'SocialCard',
};
</script>

<style lang="scss" scoped>
// Variables
$color-bg: #ffffff;
$color-border: #e4e4e7;
$color-text-primary: #000000;
$color-text-secondary: dimgray;
$color-btn-bg: #ffffff;
$color-btn-hover: #f2f2f2;
$border-radius-card: 20px;
$border-radius-btn: 8px;
$spacing-unit: 8px;

.social-card {
  background-color: $color-bg;
  border: 1px solid $color-border;
  border-radius: $border-radius-card;
  margin: 72px auto;
  max-width: 320px;
  min-width: 300px;
  padding: ($spacing-unit * 3) ($spacing-unit * 2);

  &__header {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__avatar {
    border-radius: 50%;
    height: 56px;
    object-fit: cover;
    width: 56px;
  }

  &__info {
    margin-bottom: 12px;
    text-align: center; // Changed to center as it looks like a centered card layout
  }

  &__name {
    font-size: 16px;
    font-weight: 500;
    line-height: 1.2;
    margin: $spacing-unit 0;
  }

  &__role {
    color: $color-text-secondary;
    font-size: 14px;
    margin: 0;
  }

  &__action {
    background-color: $color-btn-bg;
    border: 0;
    border-radius: $border-radius-btn;
    box-shadow:
      rgba(51, 51, 51, 0.06) 0px 2px 4px,
      rgb(233, 233, 233) 0px 0px 0px 1px,
      rgba(61, 61, 61, 0.08) 0px -0.5px 0.5px inset;
    cursor: pointer;
    padding: $spacing-unit ($spacing-unit * 2);
    transition: background-color 0.2s ease;

    &:hover {
      background-color: $color-btn-hover;
    }
  }
}
</style>